import Vue from "vue";
import { MethodService } from "@/utils/serviceModel";
import { Prop, Watch, Component, Model } from "vue-property-decorator";
import { State } from "vuex-class";

@Component
export default class CreateService extends Vue {
  @Prop()
  protected module!: string; // 模块
  @Prop()
  protected cls!: string; // 类名

  @Prop({ default: true })
  protected paginateServerSide!: boolean;

  @Prop({ default: "Id" })
  protected sortBy!: string;

  @Prop()
  protected beforeQuery: (item) => {}; // 查询前执行
  @Prop()
  protected beforeSave: (item) => void; // 保存前执行
  @Prop()
  protected beforeDelete: (item) => void; // 保存前执行
  @Prop()
  protected getDeleteArgs!: (item: IndexObject | IndexObject[]) => {};

  @Prop()
  protected argsQuery!: {}; // 查询参数

  protected tableConfig: ITableState | any = {};

  protected tableId: any = "";
  protected pagination: IPagination = {};
  protected selectedItems: any[] = [];
  protected loading: any = false;
  protected items: any[] = [];

  private totalItems: any = null;

  @State(state => state.loginer)
  protected loginer: ILoginer;

  @Watch("pagination")
  private observePagination() {
    this.query();
  }

  public async query(argument?: object) {
    if (!this.module || !this.cls) {
      return;
    }
    let args = this.getQueryargs(argument);
    if (!args) {
      this.items = [];
    }
    this.$emit("start-query");
    this.loading = "success";
    try {
      let paras = args as IndexObject;
      if (this.loginer && this.loginer.Site) {
        paras.enterprise = this.loginer.Site.Id;
      }
      let res = await this.svQuey.invokeAsyn(paras);
      let items = [];
      if (res.data.isSuccess) {
        if (this.paginateServerSide) {
          this.items = res.data.data[1];
          let total = res.data.data[0];
          this.totalItems = total;
        } else {
          this.items = res.data.data;
        }
      }
    } catch (error) {
      this.totalItems = undefined;
      this.items = [];
    } finally {
      this.loading = false;
      this.$emit("end-query");
    }
  }

  protected async custromQuery(condtions: IQueryCondtion[]) {
    if (condtions) {
      let cons: IQueryCondtion[] = [];
      for (const con of condtions) {
        if (con.prop) {
          if (con.prop.type === "boolean") {
            let temp: IQueryCondtion = {
              column: con.column,
              symbol: con.symbol,
              value: con.value ? true : false
            };
            cons.push(temp);
          } else {
            if (con.value) {
              let temp: IQueryCondtion = {
                column: con.column,
                symbol: con.symbol,
                value: con.value
              };
              cons.push(temp);
            }
          }
        }
      }

      let args: IndexObject = {
        conditions: cons,
        pagination: this.pagination
      };
      if (this.loginer && this.loginer.Site) {
        args.enterprise = this.loginer.Site.Id;
      }
      this.loading = "success";
      try {
        this.$emit("start-custom-query");
        let res = await this.svCustomQuery.invokeAsyn(args);
        let items = [];
        if (res.data.isSuccess) {
          if (this.paginateServerSide) {
            this.items = res.data.data[1];
            let total = res.data.data[0];
            this.totalItems = total;
          } else {
            this.items = res.data.data;
          }
        }
      } catch (error) {
        this.totalItems = undefined;
        this.items = [];
      } finally {
        this.loading = false;
        this.$emit("end-custom-query");
      }
    }
  }

  protected async deleteItem(model: IndexObject) {
    if (model) {
      try {
        await this.$dialogConfirm();
        if (this.beforeDelete) {
          this.beforeDelete(model);
        }
        try {
          this.$setLoading(true);
          let args: {} = { ids: [model.Id] };
          if (this.getDeleteArgs) {
            args = {
              ids: [this.getDeleteArgs(model)]
            };
          }
          await this.svDelete.invokeAsyn(args);
          this.$emit("delete-after", model);
          this.$setLoading(false);
          this.query();
        } catch (error) {}
      } catch (error) {}
    }
  }
  // 删除多项
  protected async deleteItems() {
    if (this.selectedItems.length > 0) {
      let args: any = null;
      if (this.getDeleteArgs) {
        args = this.getDeleteArgs(this.selectedItems);
      } else {
        args = this.selectedItems.map(m => m.Id);
      }
      this.$emit("deleteItems", args);
      try {
        await this.$dialogConfirm();

        try {
          this.$setLoading(true);
          await this.svDelete.invokeAsyn({
            ids: args
          });
          this.$emit("delete-after", args);
          this.$setLoading(false);
          this.query();
        } catch (error) {}
      } catch (error) {}
    }
  }

  public async saveItem(model) {
    try {
      if (this.beforeSave) {
        this.beforeSave(model);
      }
      if (this.loginer && this.loginer.Site) {
        model.EnterPriseId = this.loginer.Site.Id;
        model.EnterPriseName = this.loginer.Site.Name;
      }
      this.$setLoading(true);
      await this.svSave.invokeAsyn({ item: model });
      this.$emit("save-after", model);
      this.$setLoading(false);
      this.query();
    } catch (error) {}
  }

  protected async moveupItem(model) {
    try {
      this.$setLoading(true);
      await this.svMoveUp.invokeAsyn(model.Id);
      this.$setLoading(false);
      this.query();
    } catch (error) {}
  }

  protected async movedownItem(model) {
    try {
      this.$setLoading(true);
      await this.svMoveDown.invokeAsyn(model.Id);
      this.$setLoading(false);
      this.query();
    } catch (error) {}
  }

  created() {
    this.createMethods();
  }
  mounted() {
    this.getTableId();
    this.query();
  }

  @Watch("module")
  private observeModule() {
    this.createMethods();
    this.getTableId();
    this.query();
  }
  @Watch("cls")
  private observeCls() {
    this.createMethods();
    this.getTableId();
    this.query();
  }

  protected createMethods() {
    if (this.module && this.cls) {
      this.svQuey = this.getService("query");
      this.svDelete = this.getService("delete");
      this.svSave = this.getService("save");
      this.svGetOptions = this.getService("getOptions");
      this.svGetTableId = this.getService("getTableId");
      this.svMoveUp = this.getService("move_up");
      this.svMoveDown = this.getService("move_down");
      this.svCustomQuery = this.getService("custom_conditions_query");
    }
  }

  // 获取查询参数，添加分页信息
  protected getQueryargs(paras) {
    let args = paras ? paras : this.argsQuery;
    if (args) {
      if (this.paginateServerSide) {
        args = {
          ...args,

          pagination: this.pagination
        };
      }
      if (this.beforeQuery) {
        return this.beforeQuery(args);
      }
    }

    return args;
  }

  protected async getTableId() {
    if (!this.svGetTableId) {
      return;
    }
    let res = await this.svGetTableId.invokeAsyn();
    if (res.data.isSuccess) {
      this.tableId = res.data.data;
      return this.tableId;
    }
    this.tableId = undefined;
    return undefined;
  }

  protected getService(method: string) {
    return this.$createService(this.module, this.cls, method);
  }

  protected svGetTableId: MethodService;
  protected svQuey: MethodService; // 查询
  protected svSave: MethodService; // 保存
  protected svDelete: MethodService; // 刪除
  protected svGetOptions: MethodService; // 获取配置
  protected svMoveUp: MethodService;
  protected svMoveDown: MethodService;
  protected svCustomQuery: MethodService;
}
